var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.7 49.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.19,31.31c-3-3-2.87-6.11-2.62-10.48,0-1.12.13-2.37.13-3.62C33.7,11.48,28.21,6,22.6,4.12V3.74a3.75,3.75,0,0,0-7.49,0v.38C9.62,6,4,11.48,4,17.21a33,33,0,0,0,.12,3.5c.25,4.36.38,7.48-2.61,10.47A5,5,0,0,0,0,35.3a5.28,5.28,0,0,0,2.12,3.87,26.22,26.22,0,0,0,8.48,4.36c.62,2.75,3.37,5.74,8.23,5.74s7.61-3,8.24-5.74a29.07,29.07,0,0,0,8.48-4.36,5.2,5.2,0,0,0,.62-7.86Zm-3.62,4a22.83,22.83,0,0,1-27.44,0A.39.39,0,0,1,5,35.05c0-.12,0-.12.12-.25,4.62-4.49,4.37-9.48,4.12-14.22,0-1.12-.13-2.12-.13-3.24,0-3.87,5.49-8.73,9.73-8.73s9.86,4.86,9.86,8.73a29.3,29.3,0,0,1-.13,3.37c-.25,4.74-.5,9.73,4.12,14.22a.42.42,0,0,1,.12.25C32.7,35.18,32.7,35.3,32.57,35.3Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.b920b3ca.svg";
export { ForwardRef as ReactComponent };